/* eslint-disable warp-drive/no-legacy-request-patterns */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import Controller from '@ember/controller';

import { isEmpty } from '@ember/utils';
import moment from 'moment';

const today = moment().format('YYYY-MM-DD');

export default class DentalServiceController extends Controller {
  @action
  setEnd(value) {
    this.end = value;
  }

  @action
  setStart(value) {
    this.start = value;
  }

  queryParams = ['start', 'end'];

  // Services
  @service
  store;

  title = 'Dental List for New Enrolments';
  @tracked start = today;
  @tracked end = today;

  get students() {
    let start = moment(this.start, 'YYYY-MM-DD');
    let end = moment(this.end, 'YYYY-MM-DD');

    return this.model.people.filter((person) => {
      if (isEmpty(person.get('learner.enrolmentId'))) {
        // No enrolment ID to look up - skip this learner.
        return false;
      }

      let enrolment = this.store.peekRecord(
        'people/enrolment',
        person.get('learner.enrolmentId'),
      );
      if (isEmpty(enrolment) || isEmpty(enrolment.entryDate)) {
        // No enrolment record returned by back end, or no entryDate defined.  Skip this learner.
        return false;
      }

      let entryDate = moment(enrolment.entryDate, 'YYYY-MM-DD');
      if (!entryDate.isValid()) {
        return false;
      }

      return entryDate.isSameOrAfter(start) && entryDate.isSameOrBefore(end);
    });
  }
}
